export enum ReadStatus {
  Complete = 'Complete',
  Warning = 'Warning',
  Waiting = 'Waiting',
  Unknown = 'Unknown',
  Terminated = 'Terminated',
  Error = 'Error',
}
